export const introduce = {
  text: `### 使用方法
  + • 绿色区域（指标 < 0.5）：矿工收入比年平均水平低了50%，历史上只发生过五次，每次都对应了市场周期的底部。
  + • 红色区域（指标在 > 4）：矿工收入远超平均水平，容易引起矿工的抛售获利。
  
  ### 指标原理
  + 普埃尔倍数 = 采矿利润 ÷ 365天采矿利润均值
  + 普埃尔倍数站在挖矿的角度对比特币做出估值，通过矿工的盈利状态对比特币的基本面进行评估。
  + 更多介绍见：[普埃尔倍数原理](https://medium.com/unconfiscatable/the-puell-multiple-bed755cfe358)
  
  ### 创作者
  该指标由 [David Puell](https://twitter.com/kenoshaking) 创建`,
  height: 1430,
};
